import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';
import {
  apolloThrowIfNotSuccess,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers/custom-operators';

import {
  SettingsCompanyDetailsCountryListDto,
  SettingsCompanyDetailsDto,
} from '../../dtos';
import {
  SETTINGS_COMPANY_DETAILS_COUNTRY_LIST_QUERY,
  SETTINGS_COMPANY_DETAILS_MUTATION,
  SETTINGS_COMPANY_DETAILS_QUERY,
} from '../../graphql';
import { SettingsCompanyDetailsEditParams } from '../../models';

@Injectable({ providedIn: 'root' })
export class SettingsCompanyDetailsService {
  private clientName = APOLLO_CLIENT_NAMES.contact;

  constructor(private readonly apollo: Apollo) {}

  getSettingsCompanyDetails(): Observable<SettingsCompanyDetailsDto> {
    const fieldName =
      getQueryRootFieldName(SETTINGS_COMPANY_DETAILS_QUERY) ||
      'userCompanyDetails';

    return this.apollo
      .use(this.clientName)
      .query({
        query: SETTINGS_COMPANY_DETAILS_QUERY,
        fetchPolicy: 'no-cache',
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((result: any) => result?.data?.userCompanyDetails),
      );
  }

  getSettingsCompanyDetailsCountryList(): Observable<SettingsCompanyDetailsCountryListDto> {
    const fieldName =
      getQueryRootFieldName(SETTINGS_COMPANY_DETAILS_COUNTRY_LIST_QUERY) ||
      'getCountries';

    return this.apollo
      .use(this.clientName)
      .query({
        query: SETTINGS_COMPANY_DETAILS_COUNTRY_LIST_QUERY,
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((results: any) => results?.data?.getCountries),
      );
  }

  editSettingsCompanyDetails(params: SettingsCompanyDetailsEditParams) {
    const fieldName =
      getQueryRootFieldName(SETTINGS_COMPANY_DETAILS_MUTATION) ||
      'updateCompany';

    return this.apollo
      .use(this.clientName)
      .mutate({
        mutation: SETTINGS_COMPANY_DETAILS_MUTATION,
        variables: {
          updateCompanyRequest: {
            email: 'archana.shantageri@dnv.com', // TODO placeholder until API makes changes
            ...params,
          },
        },
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((result: any) => result?.data?.updateCompany),
      );
  }
}
